export default __webpack_public_path__ + "static/media/chrysoula_grigoropoulou.5987632a.png";